import { useEffect, useState } from 'react';

/**
 * Returns the status of the WeChat JSBridge.
 *
 * This value can be used to determine if this page is
 * being displayed in a WeChat browser.
 *
 * @returns true - if WeChat JSBridge has initialized
 */
export default function useIsWeChatReady() {
  const [isWeChatReady, setIsWeChatReady] = useState(false);

  useEffect(() => {
    const fn = () => {
      setIsWeChatReady(true);
    };

    document.addEventListener('WeixinJSBridgeReady', fn);

    return () => {
      document.removeEventListener('WeixinJSBridgeReady', fn);
    };
  }, []);

  return isWeChatReady;
}
